import {Component, OnInit} from '@angular/core';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {Activity} from '@shared/models/activity';
import {Post} from '@shared/models/post';
import {Question} from '@shared/models/question';
import {IVideo, VideoSubType} from '@api/models/video/video';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';
import {EntityType} from '@lib/models/entity/entity-type';

@Component({
  selector: 'app-match-live-ticker-tab',
  templateUrl: './match-live-ticker-tab.component.html',
  styleUrls: ['./match-live-ticker-tab.component.scss']
})
export class MatchLiveTickerTabComponent implements OnInit {

  public videos: IVideo[] = [];
  public entityType = EntityType.Event;
  // pagination
  private page = 1;
  private pageSize = 12;
  private maxPage = 3;
  private getAllEntries = false;

  constructor( public matchDetailViewService: MatchDetailViewService,
               private adCampaignService: AdCampaignService,
               private analyticsService: AnalyticsService) { }

  public ngOnInit(): void {
    this.adCampaignService.setPlacement(AdCampaignPlacement.Ticker);
    const match = this.matchDetailViewService.data.match;
    if (match.videos_native?.length > 0) {
      this.videos = match.videos_native;
    }
  }

  public getNativeVideoTitle(subtype: VideoSubType): string {
    if (subtype === VideoSubType.Replay) {
      return 'Livestream';
    }
    return 'Highlights';
  }

  public getNativeVideoTimeString(subtype: VideoSubType): string {
    if (subtype === VideoSubType.Replay) {
      return 'Replay';
    }
    return 'Zusammenfassung';
  }

  public isLoading(): boolean {
    return this.matchDetailViewService.data == null ||
      this.matchDetailViewService.data.homeTeam == null ||
      this.matchDetailViewService.data.awayTeam == null;
  }

  public getEntries(): (Activity | Question | Post)[] {
    if (this.getAllEntries) {
      return this.matchDetailViewService.data.getLivetickerEntries(0, this.getEntriesCount());
    }
    return this.matchDetailViewService.data.getLivetickerEntries(0, this.page * this.pageSize)
  }


  public getPost(entry: any): Post {
    return entry instanceof Post ? entry : null;
  }

  public getActivity(entry: any): Activity {
    return entry instanceof Activity ? entry : null;
  }

  private getEntriesCount(): number {
    return this.matchDetailViewService.data.entries.filter(value => {
      return !(value instanceof Question);
    }).length
  }

  public showHasNoEntries(): boolean {
    return this.getEntriesCount() === 0;
  }

  // needed to be able to recognize changes in array objects
  public trackItem(index: number, item: any): any {
    return JSON.stringify(item);
  }

  // Pagination
  public showLoadMore(): boolean {
    return this.getEntriesCount() > this.pageSize * this.page && !this.getAllEntries;
  }

  public onLoadMore() {
    this.analyticsService.sendPageView();
    this.page += 1;
    if (this.page === this.maxPage) {
      this.getAllEntries = true;
    }
  }
}
